// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__1kGiJ","input":"Input_input__2i-UX","label":"Input_label__DEhL2","error":"Input_error__ckNoN"};